export const pftPlageSelectorProps = () => ({
  article: {
    type: Object,
    required: true
  },
  showButton: {
    type: Boolean,
    required: false,
    default: true
  },
  selectedIndex: {
    type: Number,
    required: false,
    default: null
  },
  dropUp: {
    type: Boolean,
    required: false,
    default: false
  },
  size: {
    type: String,
    required: false,
    default: "md"
  },
  dropdownPosition: {
    type: String,
    required: false,
    default: "left"
  },
  isLight: {
    type: Boolean,
    required: false,
    default: false
  },
  pftDetail: {
    type: Boolean,
    required: false,
    default: false
  },
  quantite: {
    type: Number,
    required: false,
    default: null
  },
  selectedPlages: {
    type: Array,
    required: false,
    default: null
  },
  variant: {
    type: String,
    required: false,
    default: null
  },
});

export const usePftPlageEmits = () => ([
  "addToCart",
  "deleteFromCart",
  "plageSelected"
]);

export const usePftPlageSelector = (props) => {

  const isPanier = computed(() => {
    return props.variant === "panier";
  });

  const pftClasses = computed(() => {
    return [
      "c-pft-plage-selector",
      props.size && `c-pft-plage-selector--${props.size}`,
      isPanier.value && `c-pft-plage-selector--panier`,
      isBuffetSelected.value && `c-pft-plage-selector--buffet-selected`
    ];
  });

  const pftConf = computed(() => {
    if (props.article.attributes) {
      return props.article.attributes.pft_conf;
    }
    return props.article.pft_conf;
  });

  const buffetConf = computed(() => {
      return {
        ...props.article.attributes ?? props.article,
      }
  })

  const selectedPlageCount = (plage) => {
    if (props.selectedIndex !== null) {
      return props.selectedIndex === plage ? 1 : 0
    }
    return props.selectedPlages?.filter((el) => el.indexPoids === plage).length;
  };

  const isSelectedPlage = (plage) => {
    return props.selectedPlages?.some((el) => {
      return el.quantite === plage.LIB_POIDS
    });
  }

  const plages = computed(() => {
    if(isBuffet.value) {
      const plages = [];
      for(let i = buffetConf.value.qte_min_panier; i <= buffetConf.value.qte_max_panier; i += buffetConf.value.qte_pas) {
        plages.push({
          LIB_POIDS: i,
          PRIX: i * buffetConf.value.prix,
        });
      }
      return plages
    }
    return pftConf.value.PLAGE;
  });

  const isBuffet = computed(() => {
    return !!buffetConf.value.qte_pas;
  });

  const isBuffetSelected = computed(() => {
    return props.quantite > 0 && isBuffet.value;
  });

  const showInfoConso = computed(() => {
    return (
      parseInt(pftConf.value.CONF.MODE_AFFICHAGE) !== 1
    );
  });

  const selectedPlage = computed(() => {
    if (props.selectedIndex === null) {
      return;
    }
    return plages.value[props.selectedIndex];
  })

  return {
    pftClasses,
    plages,
    buffetConf,
    showInfoConso,
    isPanier,
    isBuffet,
    selectedPlage,
    isBuffetSelected,
    isSelectedPlage,
    selectedPlageCount
  };
};
